/* eslint-disable no-unused-expressions */
// ** React Imports
import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// ** Custom Hooks
import useJwt from "@src/auth/jwt/useJwt";

// ** Third Party Components
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";

// ** Actions
import { handleLogin } from "@store/authentication";

// ** Context
import { AbilityContext } from "@src/utility/context/Can";

// ** Custom Components
import InputPasswordToggle from "@components/input-password-toggle";

// ** Utils
import { getHomeRouteForLoggedInUser } from "@utils";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import UILoader from "@components/ui-loader";

// ** Reactstrap Imports
import {
  Col,
  Form,
  Input,
  Label,
  Button,
  CardTitle,
  FormFeedback,
  // Spinner,
} from "reactstrap";
import Spinner from "@components/spinner/Loading-spinner";
import { ReactComponent as Mark } from "../../../assets/images/svg/mark-icon.svg";

// ** Styles
import "@styles/react/pages/page-authentication.scss";

import UncutHeader from "../../components/uncutHeader";
import LoginFooter from "../../components/uncutFooter";
import toast from "react-hot-toast";
import ToastContent from "../../components/toast/toast";
import { Check } from "react-feather";
import ResetPasswordModal from "./resetPasswordModal/ResetPasswordModal";
import { AUTH_ROUTES, USER_ROUTES } from "../../../constant/route";
import { getErrorMsg } from "../../../common/ErrorMessages/errorMessage";
import Loader from "../../../common/Loader/Loader";
import ReCaptcha from "../../../recaptcha/recaptcha";

// ** Third Party Components
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { reSendEmail } from "../../../services/auth.services";

const MySwal = withReactContent(Swal);

const LoginUncut = () => {
  const location = useLocation();
  const params = new URLSearchParams(location?.search);

  const timeout = params.get("timeout");
  const success = params.get("success");
  const error = params.get("error");
  const email = params.get("email");

  // ** Hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ** State
  const [modal, setModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  // const [inValidToken, setValidToken] = useState(true);

  const ability = useContext(AbilityContext);

  // const handleCustomButtonClick = (value) => {
  //   // console.log("Custom button clicked!");
  //   reSendEmail(value)
  //     .then((res) => {
  //       console.log(res);
  //       toast((t) => (
  //         <ToastContent
  //           t={t.id}
  //           message={res?.data?.message}
  //           icon={<Check size={12} />}
  //         />
  //       ));
  //       // MySwal.fire({
  //       //   title: "Email Send Successfully.",
  //       //   icon: "success",
  //       //   customClass: {
  //       //     confirmButton: "btn btn-primary",
  //       //   },
  //       //   buttonsStyling: false,
  //       // });
  //     })
  //     .catch((err) => getErrorMsg(err));
  // };

  const handleFooterAlert = async (value) => {
    return await MySwal.fire({
      text: `We're sorry, but your email has not been verified yet. Please check your inbox for a verification email that was sent when you registered. If you cannot find the email, please also check your spam or junk folder. If you still haven't received the verification email, you can request a new one by clicking on the "Resend Verification Email" button below`,
      icon: "error",
      confirmButtonText: "Resend Verification Email",
      customClass: {
        confirmButton: "btn btn-primary ",
      },
      preConfirm: () => {
        return reSendEmail(value)
          .then((res) => {
            toast((t) => (
              <ToastContent
                t={t.id}
                message={res?.data?.message}
                icon={<Check size={12} />}
              />
            ));
          })
          .catch((error) => {
            getErrorMsg(error);
          });
      },
    });
  };

  // ** LoginSchema
  const defaultValues = {
    loginEmail: "",
    password: "",
  };

  const loginSchema = yup.object({
    loginEmail: yup
      .string()
      .email("Plaase enter valid Email adress")
      .required("Email is Raquired")
      .max(60, "Email should be not greater than 20 character")
      .trim()
      .typeError("Email is Required"),
    password: yup.string().required("Pasword is Required"),
    // .matches(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,
    //   "Must Contain 8-20 Characters, One Uppercase, One Lowercase, One Number, And One Special Case Character"
    // ),
  });

  const {
    control,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(loginSchema) });

  const onSubmit = (data) => {
    setIsLoading(true);
    if (Object.values(data).every((field) => field.length > 0)) {
      useJwt
        .login({ email: data.loginEmail, password: data.password })
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.data?.user?.is_admin === "0") {
            const role =
              res?.data?.data?.user?.is_admin === "0" ? "user" : "admin";
            const data = {
              ...res.data?.data?.user,
              role,
              ability: [{ action: "manage", subject: "all" }],
              accessToken: res.data.data.access_token,
              refreshToken: res.data.data.refresh_token,
            };
            dispatch(handleLogin(data));
            ability.update(data?.ability);
            if (data?.role === "user" && email) {
              navigate(USER_ROUTES.MY_PROJECTS);
            } else {
              navigate(getHomeRouteForLoggedInUser(data?.role));
            }
            toast((t) => (
              <ToastContent
                t={t.id}
                message={`You have successfully logged in.`}
                icon={<Check size={12} />}
              />
            ));
          } else {
            () => console.log("you are not authorized");
          }
        })
        .catch((err) => {
          console.log("err: ", err?.response?.data?.data);
          setIsLoading(false);

          if (err?.response?.data?.data?.email_not_verified) {
            handleFooterAlert(err?.response?.data?.data?.email);
          } else {
            getErrorMsg(err);
          }
        });
    } else {
      for (const key in data) {
        if (data[key].length === 0) {
          setError(key, {
            type: "manual",
          });
        }
      }
    }
  };

  const handleSuccess = (success) => {
    return MySwal.fire({
      title: success,
      // text: "You clicked the button!",
      icon: "success",
      customClass: {
        confirmButton: "btn btn-primary",
      },
      buttonsStyling: false,
    });
  };

  useEffect(() => {
    if (success) {
      handleSuccess(success);
      navigate({
        search: "",
      });
    } else if (error) {
      handleFooterAlert(email);
      navigate({
        search: "",
      });
    }

    if (timeout) {
      navigate({
        search: "",
      });
      window.location.reload(true);
    }
  }, []);

  return (
    <UILoader blocking={isLoading} loader={<Loader />}>
      <div className="auth-wrapper auth-cover">
        <div className="auth-inner m-0">
          <div className="container-fluid main-login-header">
            <div className="row">
              <UncutHeader />
            </div>
          </div>
          <div className="container login-wrapper">
            <div className=" welcome-container">
              <div className="row">
                <Col
                  className="d-none d-lg-flex align-items-center login-welcome"
                  lg="8"
                  sm="12"
                >
                  <div className="w-100 align-items-center justify-content-center">
                    {/* <img className="img-fluid" src={source} alt="Login Cover" /> */}
                    <h1 className="BgShine">Welcome!</h1>
                    <p>
                      Please enter your login details to access our powerful
                      collaboration platform.
                    </p>
                    <div className="platform-list">
                      <ul className="list-style-icons p-0">
                        <li>
                          <Mark />
                          Place orders
                        </li>
                        <li>
                          <Mark />
                          Send us the footage
                        </li>
                        <li>
                          <Mark />
                          Manage subscription
                        </li>
                        <li>
                          <Mark />
                          Purchase Carat club credits
                        </li>
                        <li>
                          <Mark />
                          Track project status
                        </li>
                      </ul>
                    </div>
                    <div className="help-member">
                      <p>
                        Not a member?{" "}
                        <Link to={AUTH_ROUTES.APP_REGISTER}>Sign up</Link>
                      </p>
                      <p>
                        Need help?{" "}
                        <a href="#" target="_blank">
                          View tutorials
                        </a>
                      </p>
                    </div>
                  </div>
                </Col>
                <Col className="d-flex align-items-center" lg="4" sm="12">
                  <Col className="px-xl-2 mx-auto" sm="8" md="6" lg="12">
                    <CardTitle tag="h2" className=" Client-text BgShine">
                      Client Portal
                    </CardTitle>
                    <Form
                      className="auth-login-form mt-2"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="mb-2">
                        <Label className="form-label" for="login-email">
                          Email*
                        </Label>
                        <Controller
                          id="loginEmail"
                          name="loginEmail"
                          control={control}
                          render={({ field }) => (
                            <Input
                              autoFocus
                              type="email"
                              placeholder="john@example.com"
                              invalid={errors.loginEmail && true}
                              {...field}
                            />
                          )}
                        />
                        {errors?.loginEmail ? (
                          <FormFeedback>
                            {errors.loginEmail.message}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="position-relative password-box mb-2">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" for="login-password">
                            Password*
                          </Label>
                        </div>
                        <Controller
                          id="password"
                          name="password"
                          control={control}
                          render={({ field }) => (
                            <InputPasswordToggle
                              className="input-group-merge"
                              invalid={errors.password && true}
                              {...field}
                            />
                          )}
                        />
                        {errors?.password ? (
                          <FormFeedback>{errors.password.message}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <div className="form-check mb-1">
                            <Input type="checkbox" id="remember-me" />
                            <Label
                              className="form-check-label"
                              for="remember-me"
                            >
                              Remember Me
                            </Label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <div className="mb-1 forgot-css">
                            <Button.Ripple
                              onClick={() => setModal({ ...modal, open: true })}
                              color="flat-primary"
                            >
                              Forgot Password?
                            </Button.Ripple>
                          </div>
                        </div>
                      </div>

                      <Button
                        // disabled
                        disabled={
                          isLoading
                          // || inValidToken
                        }
                        type="submit"
                        color="primary"
                        className="themeBtn login-btn"
                      >
                        {/* <UILoader
                          blocking={isLoading}
                          loader={<Spinner color="#0b1e38" />}
                          // overlayColor="rgba(255,255,255, .5)"
                        > */}
                        Log in
                        {/* {isLoading ? "" : "Log in"} */}
                        {/* </UILoader> */}
                      </Button>
                      {/* <ReCaptcha setValidToken={() => setValidToken(false)} /> */}
                    </Form>
                  </Col>
                </Col>
              </div>
            </div>

            <LoginFooter />
          </div>
        </div>

        <ResetPasswordModal open={modal} setOpen={setModal} />
      </div>
    </UILoader>
  );
};

export default LoginUncut;
